// repeated in src/util/weather/Weather.ts

export type MonthlyRainfallProfile = { total: number; rainDays: number }
export type AnnualRainfallProfile = MonthlyRainfallProfile[]

export enum ForecastPeriod {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
}

/// Examples which dont belong in this file
